export default "__VITE_ASSET__BnjaZ7oh__"